const STORAGE_KEY = 'organisation'

type StorageLike = {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

const getStorage = (): StorageLike | null => {
  try {
    return 'localStorage' in globalThis ? ((globalThis as any).localStorage as StorageLike) : null
  } catch {
    return null
  }
}

/**
 * The signed-in organisation, read straight from storage. Framework-agnostic on purpose so
 * non-Vue code — service layers in particular — can select behaviour by organisation without
 * depending on the UI package. Reactive consumers use `useOrganisation` from `@staff/ui`.
 */
export const readOrganisation = (): string | null => getStorage()?.getItem(STORAGE_KEY) ?? null

export const writeOrganisation = (name: string): void => {
  getStorage()?.setItem(STORAGE_KEY, name)
}

export const removeOrganisation = (): void => {
  getStorage()?.removeItem(STORAGE_KEY)
}
